<template>
  <FormSelect
    :disabled="disabled || !company"
    :name="$t('orderForm.type')"
    :options="typeOptions"
    required
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
import FormSelect from '@/components/Form/Select/index.vue'

import { ORDER_TYPE_OPTIONS } from '@/api/orders'

export default {
  name: 'OrderTypeSelect',
  components: {
    FormSelect,
  },
  props: {
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    company: { type: Object, required: true },
  },
  computed: {
    typeOptions() {
      return ORDER_TYPE_OPTIONS.filter(type => this.company.settings.available_order_types?.includes(type.value)).map(
        option => ({ value: option.value, label: this.$t(option.label_i18n) }),
      )
    },
  },
}
</script>
